<template>
  <main class="bg-[#111314]">
    <header
      class="bg-[#111314] flex items-center h-24 px-8 border-b border-white border-opacity-10"
    >
      <div class="container m-auto flex items-center justify-between">
        <MobiusLogo variant="light" />
        <span class="mob-btn mob-btn--on-dark" href="#"> Contáctanos: <b>administrador@mobiusml.com</b></span>
      </div>
    </header>

    <div
      class="bg-no-repeat bg-top md:bg-center bg-contain md:bg-cover"
      style="background-image: url('/images/hero-mesh-home.png')"
    >
      <section class="text-center py-[54px]">
        <a
          href="/olimpiadas"
          class="text-sm sm:text-base border border-white border-opacity-70 rounded-full text-white inline-block space-x-4 px-5 py-2 mx-4"
        >
          <span>Olimpiada Mobius Abril 2024</span>
        </a>

        <div class="space-y-8 mt-6">
          <h1
            class="text-4xl sm:text-5xl md:text-6xl font-bold text-white px-4"
          >
            Aprende matemáticas <br />
            <span class="text-gradient">adaptadas a ti</span>
          </h1>
          <p class="text-white text-opacity-75 max-w-xl m-auto px-4">
            Mobius utiliza técnicas de Machine learning e inteligencia
            artificial para proporcionar contenido y orientación adaptados a tus
            necesidades.
          </p>

          <div class="flex justify-center gap-4">
            <router-link
              class="mob-btn mob-btn--primary min-w-[148px]"
              to="/v2/auth/register"
            >
              Regístrate
            </router-link>
            <router-link
              class="mob-btn mob-btn--outline min-w-[148px]"
              to="/v2/auth/login"
            >
              Ingresa
            </router-link>
          </div>
        </div>
      </section>

      <div>
        <img
          class="w-full max-w-[934px] m-auto -mt-12"
          src="/images/video-thumbnail-home.png"
          alt=""
          @click="openModal"
          v-if="!modalVisible"
        />

        <div v-if="modalVisible" class="w-full max-w-[934px] m-auto -mt-12 pb-4">

            <video controls width="100%" height="480" autoplay>
              <source src="/video/Video Mobius.mp4" type="video/mp4">
              Tu navegador no soporta la reproducción de video.
            </video>

        </div>
      </div>
    </div>
  </main>
</template>

<script>

import Modal from "@/components/Modal.vue";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  components: {
    Modal,
    MobiusLogo,
  },
  data() {
    return {
      modalVisible: false
    };
  },
  methods: {
    openModal() {
      this.modalVisible = true;
    }
  },
  name: "HomeV2",
};
</script>
